import { Component, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
    TCI_APP_MONITORING_REQUEST_TYPE,
    ITCIApplicationsMonitoringRequest,
    TCITenantSelectorType
} from "@tci/common";
import { BaseAppDetailMenuComponentInput, BaseAppDetailMenuComponentOutput } from "../../../../ng-app-details-menu";
import { AbstractTCITenantComponent } from "../../../../../ng-tenant/tci-tenant-component";
import { NgToastrService } from "../../../../../ng-shared/ng-components/ng-toastr/ng-toastr.service";
import { BaseSubmenuMonitoringTriggersService } from "./base-submenu-triggers.service";

@Component({
    selector: TCITenantSelectorType.TCI_MENU_APP_MONITORING_TRIGGERS.toString(),
    templateUrl: "./base-submenu-triggers.component.html",
    styleUrls: ["./base-submenu-triggers.component.less"]
})
export class BaseSubmenuTriggersComponent<E, I extends BaseAppDetailMenuComponentInput, O extends BaseAppDetailMenuComponentOutput<E>>
    extends AbstractTCITenantComponent<E, I, O> implements OnInit, OnDestroy {
    constructor(
        protected resourceSvc: BaseSubmenuMonitoringTriggersService,
        protected translate: TranslateService,
        protected toastr: NgToastrService
    ) {
        super();
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
    }

    generateReqInput(): ITCIApplicationsMonitoringRequest {
        return {
            request_type: TCI_APP_MONITORING_REQUEST_TYPE.APP_RESOURCE_CPU
        } as ITCIApplicationsMonitoringRequest;
    }

}
